import { useEffect, useContext } from 'react';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import Services from '../services';
import usePageStore from '../store/pageStore';

export default function useGetEmailsPreferences() {
  const { setErrorMessage, store } = useContext(GeneralContext);
  const setFetchedData = usePageStore((state) => state.setFetchedData);
  const setEmailsPreferences = usePageStore(
    (state) => state.setEmailsPreferences,
  );
  const setLoadingEmailsPreferences = usePageStore(
    (state) => state.setLoadingEmailsPreferences,
  );
  useEffect(() => {
    const fetchConfigs = async () => {
      if (store) {
        setLoadingEmailsPreferences(true);
        const preferences = await Services.getEmailsPreferences({
          storeId: store.id,
        });
        if (!preferences) {
          setLoadingEmailsPreferences(false);
          return;
        }
        setEmailsPreferences(preferences);
        setFetchedData(preferences, 'emailsPreferences');
        setLoadingEmailsPreferences(false);
      }
    };
    fetchConfigs();
  }, [store]);
}
